// var imgUrl = 'https://21du.sd.sgcc.com.cn/oss/'
var imgUrl = 'https://cdn.zhijingwuxian.com/'
export default { imgUrl }
